import * as Icons from "lucide-react";

// Renders a lucide icon by string name with a fallback.
export default function Icon({ name, className = "h-6 w-6", strokeWidth = 1.6 }) {
  const Cmp = Icons[name] || Icons.Circle;
  return <Cmp className={className} strokeWidth={strokeWidth} />;
}
